module.exports = __webpack_public_path__ + "static/img/collaboration_pic@2x.2b13c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180102/collaboration_pic@2x.png
// module id = 245
// module chunks = 1